
  <svg class="spinner" viewBox="25 25 50 50">
      <style type="text/css">
          body {
              overflow: hidden;
          }

          circle {
              stroke: url(#loadingGradient)
          }
      </style>
      <defs>
          <linearGradient id="loadingGradient">
              <stop offset="0%" stop-color="#303c74" stop-opacity="1"/>
              <stop offset="50%" stop-color="#303c74" stop-opacity="0.5"/>
              <stop offset="75%" stop-color="#303c74" stop-opacity="0.3"/>
              <stop offset="80%" stop-color="#303c74" stop-opacity="0.2"/>
              <stop offset="85%" stop-color="#303c74" stop-opacity="0.1"/>
              <stop offset="90%" stop-color="#303c74" stop-opacity="0"/>
          </linearGradient>
      </defs>
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
  </svg>